import React, { useRef } from "react";
import styled from "styled-components";
import { uploadDocument } from "../services/solicitud";
import {toast } from 'react-toastify';

const ButtonUploader = styled.button`
  padding: 10px 20px;
  background:transparent;
  color: black;
  border: 1px solid #00000030;
  border-radius: 5px;
  cursor: pointer;
  height:100%;

  &:hover {
    background-color: #3592C8;
  }
`;

const FileButtonUploader = ({ categoria, onUploadSuccess,disabled }) => {
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    const queryParams = new URLSearchParams(window.location.search);
    const id_solicitud = queryParams.get('id_postulacion');

    if (file) {
      if (!['application/pdf', 'image/jpeg'].includes(file.type)) {
        toast.error('Solo se permiten archivos PDF o JPG');
        return;
      }
      if (file.size > 3 * 1024 * 1024) { 
        toast.error('El archivo no debe pesar más de 10MB');
        return;
      }

      const base64 = await convertToBase64(file);

      const doc = {
        id_solicitud,
        tipo_documento: file.type,
        documento: base64,
        categoria,
        nombre_documento: file.name,
      };

      try {
        const newDoc = await toast.promise(
          uploadDocument(doc),
          {
            pending: 'Subiendo archivo: ' + file.name,
            success: 'Archivo subido con éxito',
            error: 'Ocurrió un error al subir el archivo'
          }
        );

        if (onUploadSuccess) {
          onUploadSuccess(newDoc);
        }

      } catch (error) {
        console.error("Error al subir archivo:", error);
      }
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]); // Elimina el prefijo 'data:mime;base64,'
      reader.onerror = (error) => reject(error);
    });
  };

  return (
    <div style={{ display: disabled ? "none" : "block" }}>
      <input 
        type="file" 
        ref={fileInputRef} 
        style={{ display: "none" }} 
        onChange={handleFileChange} 
      />
      <ButtonUploader type="button" onClick={handleButtonClick}>
        <img width={64} src="/IMG/file_upload.png"></img>
        <p>Subir un archivo</p>
        </ButtonUploader>
    </div>
  );
};

export default FileButtonUploader;
